import { render, staticRenderFns } from "./JoeyChatbot.vue?vue&type=template&id=68cbca9a"
import script from "./JoeyChatbot.vue?vue&type=script&lang=ts"
export * from "./JoeyChatbot.vue?vue&type=script&lang=ts"
import style0 from "./JoeyChatbot.vue?vue&type=style&index=0&id=68cbca9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports